export const whitelabel: Record<string, string> = {
  // TODO: Would be good if this is managed here: https://app-eu1.hubspot.com/hubdb/26776524/table/411384021
  // AgentSelly does not need whitelabeling
  70927429839: '',
  // Valiant:
  145859503298: `
:root {
  --color-primary-50: #f7f6fc;
  --color-primary-100: #f0eef9;
  --color-primary-200: #e2e0f4;
  --color-primary-300: #b3a6df;
  --color-primary-400: #8566c1;
  --color-primary-500: #7252ac;
  --color-primary-600: #7252ac;
  --color-primary-700: #7252ac;
  --color-primary-800: #604691;
  --color-primary-900: #503b77;
  --color-primary-950: #332550;
  --color-secondary-50: #f7f6fc;
  --color-secondary-100: #f0eef9;
  --color-secondary-200: #e2e0f4;
  --color-secondary-300: #b3a6df;
  --color-secondary-400: #8566c1;
  --color-secondary-500: #7252ac;
  --color-secondary-600: #7252ac;
  --color-secondary-700: #7252ac;
  --color-secondary-800: #604691;
  --color-secondary-900: #503b77;
  --color-secondary-950: #332550;
  --color-accent-50: #f4f8ed;
  --color-accent-100: #e8eed9;
  --color-accent-200: #d3dfb7;
  --color-accent-300: #b5ca8c;
  --color-accent-400: #9ab467;
  --color-accent-500: #8cac52;
  --color-accent-600: #617937;
  --color-accent-700: #4b5d2e;
  --color-accent-800: #3d4c28;
  --color-accent-900: #364126;
  --color-accent-950: #1b2310;
  --color-gray-50: #f8fafc;
  --color-gray-100: #f1f5f9;
  --color-gray-200: #e2e8f0;
  --color-gray-300: #cbd5e1;
  --color-gray-400: #94a3b8;
  --color-gray-500: #64748b;
  --color-gray-600: #475569;
  --color-gray-700: #334155;
  --color-gray-800: #1e293b;
  --color-gray-900: #0f172a;
  --color-gray-950: #020617;
  --color-primary-default: #7252ac;
}
/*
 * Dark mode: ".dark" has the same specificity as ":root" and must come AFTER it,
 * otherwise the light palette above would win over the base ".dark" tokens.
 */
.dark {
  --color-primary-50: #231a33;
  --color-primary-100: #2c2142;
  --color-primary-200: #3b2c59;
  --color-primary-300: #52397a;
  --color-primary-400: #6b4a9c;
  --color-primary-500: #9a7bd0;
  --color-primary-600: #8566c1;
  --color-primary-700: #7252ac;
  --color-primary-800: #9a7bd0;
  --color-primary-900: #b3a6df;
  --color-primary-950: #d1c8ee;
  --color-secondary-50: #231a33;
  --color-secondary-100: #2c2142;
  --color-secondary-200: #3b2c59;
  --color-secondary-300: #52397a;
  --color-secondary-400: #6b4a9c;
  --color-secondary-500: #9a7bd0;
  --color-secondary-600: #8566c1;
  --color-secondary-700: #7252ac;
  --color-secondary-800: #9a7bd0;
  --color-secondary-900: #b3a6df;
  --color-secondary-950: #d1c8ee;
  --color-primary-default: #9a7bd0;
}
`,
};

/** Whitelabel CSS for a companyId, or '' if none. Safe against prototype keys. */
export function getWhitelabelCss(companyId: string | undefined): string {
  if (
    !companyId ||
    !Object.prototype.hasOwnProperty.call(whitelabel, companyId)
  ) {
    return '';
  }
  return whitelabel[companyId];
}
